// import React, { useEffect } from 'react';
// import CanvasJSReact from '@canvasjs/react-charts';
// import { Card, CardBody, CardHeader, Button } from 'react-bootstrap';
// import { useDispatch, useSelector } from 'react-redux';
// import { fetchTodaysActivityTrack } from '../../redux/slices/ActivityTrackSlice'; // Ensure the correct path

// const CanvasJSChart = CanvasJSReact.CanvasJSChart;

// const ActivityTrackChart = () => {
//   const dispatch = useDispatch();
//   const user = useSelector((state) => state.auth.user);

//   // Fetch activity data from Redux store
//   const { activityTrack, loading, error } = useSelector((state) => state.activityTrack.today);

//   useEffect(() => {
//     if (user && user.user_id) {
//       dispatch(fetchTodaysActivityTrack(user.user_id));
//     }
//   }, [dispatch, user]);

//   const handleRefresh = () => {
//     if (user && user.user_id) {
//       dispatch(fetchTodaysActivityTrack(user.user_id));
//     }
//   };

//   // Map activity states to numerical values
//   const dataPoints = activityTrack.map((item) => ({
//     x: new Date(item.time), // Keeping X-axis as Date-Time
//     y: item.status === 'active' ? 1 : item.status === 'inactive' ? 0 : -1, // Mapping states to Y-axis
//   }));

//   const options = {
//     animationEnabled: true,
//     animationDuration: 1000,
//     data: [
//       {
//         type: 'spline',
//         markerSize: 8,
//         dataPoints: dataPoints,
//         lineColor: 'rgba(0, 123, 255, 0.8)', // Default line color (blue)
//         markerType: 'circle',
//         toolTipContent: '{x}: {y}', // Show data on hover
//       },
//     ],
//     axisX: {
//       title: 'Time',
//       valueFormatString: 'HH:mm',
//       labelAngle: -45,
//     },
//     axisY: {
//       title: 'Activity State',
//       minimum: -1.5,
//       maximum: 1.5,
//       interval: 1,
//       labelFormatter: function (e) {
//         return e.value === 1 ? 'Active' : e.value === 0 ? 'Inactive' : 'Free Fall';
//       },
//     },
//     backgroundColor: 'transparent',
//   };

//   return (
//     <Card className='chart-card-large'>
//       <CardHeader>
//         <div style={{ 
//             padding: '10px 15px', 
//             borderBottom: '1px solid #dee2e6', 
//             backgroundColor: '#f8f9fa', 
//             textAlign: 'center' 
//           }}>
//           <h4 style={{ margin: 0, color: 'rgba(236, 15, 15, 0.85)', fontSize: '27px' }}>Activity Tracking</h4>
//         </div>
//       </CardHeader>
//       <CardBody>
//         {loading && <p>Loading...</p>}
//         {error && <p>Error: {JSON.stringify(error)}</p>}
//         {!loading && !error && (
//           <>
//             <CanvasJSChart options={options} />
//             <Button variant="primary" onClick={handleRefresh} style={{ marginTop: '10px' }}>
//               Refresh Data
//             </Button>
//           </>
//         )}
//       </CardBody>
//     </Card>
//   );
// };

// export default ActivityTrackChart;

import React, { useEffect } from 'react';
import CanvasJSReact from '@canvasjs/react-charts';
import { Card, CardBody, CardHeader, Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { fetchTodaysActivityTrack } from '../../redux/slices/ActivityTrackSlice'; // Ensure the correct path

const CanvasJSChart = CanvasJSReact.CanvasJSChart;

const ActivityTrackChart = () => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth.user);

  // Fetch activity data from Redux store
//   const { data: activityTrack, loading, error } = useSelector((state) => state.activityTrack.today);
const { activityTrack, loading, error } = useSelector((state) => state.activityTrack.today);
  useEffect(() => {
    if (user && user.user_id) {
      dispatch(fetchTodaysActivityTrack(user.user_id));
    }
  }, [dispatch, user]);

  const handleRefresh = () => {
    if (user && user.user_id) {
      dispatch(fetchTodaysActivityTrack(user.user_id));
    }
  };

  // Map activity states to numerical values
  const dataPoints = activityTrack
    ? activityTrack.map((item) => ({
        x: new Date(item.time), // X-axis: Date-Time
        y: item.status.trim() === 'Person Active' ? 1 : 
           item.status.trim() === 'Inactive' ? 0 : 
           item.status.trim() === 'Free Fall Detected' ? -1 : null,
      })).filter(item => item.y !== null) // Remove unexpected values
    : [];

  const options = {
    animationEnabled: true,
    animationDuration: 1000,
    data: [
      {
        type: 'spline',
        markerSize: 4,
        dataPoints: dataPoints,
        lineColor: 'rgba(0, 123, 255, 0.8)', // Default line color (blue)
        markerColor: 'rgba(255, 99, 132, 0.8)', // Vibrant red color
        markerType: 'circle',
        toolTipContent: '{x}: {y}', // Show data on hover
      },
    ],
    axisX: {
      title: 'Date & Time',
      valueFormatString: 'DD MMM HH:mm', // Format for better readability
      labelAngle: 180,
    },
    axisY: {
      title: 'Activity State',
      minimum: -1.5,
      maximum: 1.5,
      interval: 1,
      labelFormatter: function (e) {
        return e.value === 1 ? 'Active' : e.value === 0 ? 'Inactive' : 'Free Fall';
      },
    },
    backgroundColor: 'transparent',
  };

  return (
    <Card className='chart-card-large'>
      <CardHeader>
        <div style={{ 
            padding: '10px 15px', 
            borderBottom: '1px solid #dee2e6', 
            backgroundColor: '#f8f9fa', 
            textAlign: 'center' 
          }}>
          <h4 style={{ margin: 0, color: 'rgb(122, 114, 114)', fontSize: '27px' }}>Activity Tracking</h4>
        </div>
      </CardHeader>
      <CardBody>
        {loading && <p>Loading...</p>}
        {error && <p>Error: {JSON.stringify(error)}</p>}
        {!loading && !error && (
          <>
            <CanvasJSChart options={options} />
            <Button variant="primary" onClick={handleRefresh} style={{ marginTop: '10px' }}>
              Refresh Data
            </Button>
          </>
        )}
      </CardBody>
    </Card>
  );
};

export default ActivityTrackChart;
